import { supabase } from '@/integrations/supabase/client';
import { MonthlyMetric } from './monthlyMetricsService';
import { getMonthlyFleetActivity } from './fleetUtilizationService';

/**
 * Получает активных курьеров по месяцам на основе дат аренд
 */
export const getMonthlyActiveCouriers = async (monthsCount: number = 12): Promise<MonthlyMetric[]> => {
  try {
    console.log(`Загрузка активных курьеров по месяцам за ${monthsCount} месяцев...`);
    
    // Получаем аренды с привязанными велосипедами и платежами, группируем по месяцам
    const { data, error } = await supabase
      .from('rentals')
      .select(`
        id,
        courier_id,
        bike_id,
        created_at,
        payments!inner(
          id,
          status
        )
      `)
      .not('bike_id', 'is', null)
      .in('payments.status', ['paid', 'completed', 'success'])
      .gte('created_at', new Date(Date.now() - monthsCount * 30 * 24 * 60 * 60 * 1000).toISOString())
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Ошибка при получении данных для месячной статистики курьеров:', error);
      return [];
    }

    if (!data || data.length === 0) {
      console.log('Нет данных об арендах для расчета месячной статистики курьеров');
      return [];
    }

    // Группируем по месяцам и считаем уникальных курьеров
    const monthlyData = new Map<string, Set<string>>();
    
    data.forEach(rental => {
      if (rental.courier_id && rental.created_at) {
        const date = new Date(rental.created_at);
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        
        if (!monthlyData.has(monthKey)) {
          monthlyData.set(monthKey, new Set());
        }
        
        monthlyData.get(monthKey)!.add(rental.courier_id);
      }
    });

    // Преобразуем в массив метрик
    const metrics: MonthlyMetric[] = [];
    monthlyData.forEach((courierIds, monthKey) => {
      const [year, month] = monthKey.split('-').map(Number);
      metrics.push({
        year,
        month,
        value: courierIds.size
      });
    });

    // Сортируем по дате
    metrics.sort((a, b) => {
      if (a.year !== b.year) return a.year - b.year;
      return a.month - b.month;
    });

    // Рассчитываем рост по сравнению с предыдущим месяцем
    for (let i = 1; i < metrics.length; i++) {
      const current = metrics[i].value;
      const previous = metrics[i - 1].value;
      metrics[i].previousValue = previous;
      if (previous > 0) {
        metrics[i].growth = Math.round(((current - previous) / previous) * 100);
      }
    }

    console.log(`Получено ${metrics.length} месяцев данных об активных курьерах`);
    return metrics;
  } catch (error) {
    console.error('Ошибка при получении месячных данных об активных курьерах:', error);
    return [];
  }
};

/**
 * Получает активность парка велосипедов по месяцам (новая упрощенная метрика)
 */
export const getMonthlyBikeUtilization = getMonthlyFleetActivity;
